<div *ngIf="!appBuildInfo">
    Loading build info...
</div>
<div *ngIf="appBuildInfo">
    <br />
    <mat-card appearance="outlined">
        <mat-card-title>API Build Info</mat-card-title>
        <div class="container-fluid">

            <div class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    Build date:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.apiBuildInfo.buildTime}}
                </div>
            </div>

            <div *ngIf="appBuildInfo.apiBuildInfo.buildAgent" class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    Build job:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.apiBuildInfo.buildAgent}}/{{appBuildInfo.apiBuildInfo.buildJob}}-{{appBuildInfo.apiBuildInfo.buildNumber}}
                </div>
            </div>

            <div *ngIf="appBuildInfo.apiBuildInfo.changeSet" class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    ChangeSet:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.apiBuildInfo.changeSet}}
                </div>
            </div>
        </div>
    </mat-card>
    <br />
    <mat-card appearance="outlined">
        <mat-card-title>Web Build Info</mat-card-title>
        <div class="container-fluid">
            <div class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    Build date:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.webBuildInfo.buildTime}}
                </div>
            </div>

            <div *ngIf="appBuildInfo.webBuildInfo.buildAgent" class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    Build job:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.webBuildInfo.buildAgent}}/{{appBuildInfo.webBuildInfo.buildJob}}-{{appBuildInfo.webBuildInfo.buildNumber}}
                </div>
            </div>

            <div *ngIf="appBuildInfo.webBuildInfo.changeSet" class="row">
                <div class="col col-lg-2 col-md-3 col-sm-4">
                    ChangeSet:
                </div>
                <div class="col col-auto">
                    {{appBuildInfo.webBuildInfo.changeSet}}
                </div>
            </div>

        </div>
    </mat-card>

    <br />

    <mat-card appearance="outlined">
        <mat-card-title class="features-title">
            Features
            <div>
                <button mat-button (click)="accordion.openAll()">Expand All</button>
                <button mat-button (click)="accordion.closeAll()">Collapse All</button>
            </div>
        </mat-card-title>

        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel *ngFor="let feature of this.features">
                <mat-expansion-panel-header class="right-aligned-header">
                    <mat-panel-title>
                        {{feature.name}}
                    </mat-panel-title>
                    <mat-panel-description class="panelDescWidth300">
                        {{feature.description}}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <table>
                    <tr>
                        <td>Class Name:</td>
                        <td>{{feature.className}}</td>
                    </tr>
                    <tr>
                        <td>Full Name:</td>
                        <td>{{feature.fullName}}</td>
                    </tr>
                    <tr>
                        <td>Assembly Name:</td>
                        <td>{{feature.assemblyQualifiedName}}</td>
                    </tr>
                </table>

            </mat-expansion-panel>
        </mat-accordion>

    </mat-card>

</div>
